export default __webpack_public_path__ + "static/media/birth.ba6fbfde.png";